import { render, staticRenderFns } from "./BoardsList.vue?vue&type=template&id=1523a148&"
import script from "./BoardsList.vue?vue&type=script&lang=js&"
export * from "./BoardsList.vue?vue&type=script&lang=js&"
import style0 from "./BoardsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports